import { History } from 'lucide-react-native';

import type { CaseFact } from '../../model/types';
import { REPLY_DRAFT_COPY } from '../copy';
import { Disclosure } from '../shared/Disclosure';

import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';

/**
 * The case as the brief read it, right under the question: the expert decides
 * against it, so it stays in view rather than hiding behind a section.
 */
export function CaseDetails({ facts }: { facts: CaseFact[] }) {
  if (facts.length === 0) {
    return null;
  }

  return (
    <VStack className="gap-0.5" testID="reply-draft-case-facts">
      {facts.map((fact) => (
        <Text key={fact.label} size="sm" className="text-typography-700">
          <Text size="sm" className="font-semibold text-typography-700">
            {fact.label}:
          </Text>{' '}
          {fact.value}
        </Text>
      ))}
    </VStack>
  );
}

/**
 * The expert's own record on similar cases, as a section matching "changed
 * recently" beside it: an icon, the count, and a plain "none" when the expert
 * has no similar case on record, rather than a section that opens to nothing.
 */
export function SimilarCases({
  history,
  caseCount,
}: {
  history: string | null;
  caseCount: number | null;
}) {
  const isEmpty = !history || caseCount === 0;

  return (
    <Disclosure
      label={REPLY_DRAFT_COPY.historyHeading(isEmpty ? 0 : caseCount)}
      icon={History}
      emptyText={isEmpty ? REPLY_DRAFT_COPY.historyEmpty : null}
      testID="reply-draft-history">
      <Text size="sm" className="text-typography-900">
        {history}
      </Text>
    </Disclosure>
  );
}
